import padma1 from "./6.webp";
import padma2 from "./8.webp";

const padma = [padma1, padma2];

export default padma;
